import { render, staticRenderFns } from "./CotStatiListComponent.vue?vue&type=template&id=42bfc638"
import script from "./CotStatiListComponent.vue?vue&type=script&lang=js"
export * from "./CotStatiListComponent.vue?vue&type=script&lang=js"
import style0 from "./CotStatiListComponent.vue?vue&type=style&index=0&id=42bfc638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports